export const stateName = 'verifications';
export let EmailCodeView;

(function (EmailCodeView) {
  EmailCodeView["EnterCode"] = "enterCode";
  EmailCodeView["NotReceiveEmail"] = "notReceiveEmail";
  EmailCodeView["Success"] = "success";
})(EmailCodeView || (EmailCodeView = {}));